import { render } from "./About.vue?vue&type=template&id=7698dec0&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=7698dec0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7698dec0"

export default script